import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coachtraining-calendar',
  templateUrl: './coachtraining-calendar.component.html',
  styleUrls: ['./coachtraining-calendar.component.scss']
})
export class CoachtrainingCalendarComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
